export default "__VITE_ASSET__DmchH0Uk__"